// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggle-checkbox[data-v-ef19c16a]:checked {\n@apply: right-0 border-green-400;\n  right: 0;\n  border-color: #68d391;\n}\n.toggle-checkbox:checked + .toggle-label[data-v-ef19c16a] {\n@apply: bg-green-400;\n  background-color: #68d391;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
